import { useRef, useEffect } from 'react';
import { assertStickyParentPosition, getUpdatedStickyState, hasStickyStateChanged, } from './stickyEmulation';
export function useBaseSticky(state, onChange, options, containerRef, childRef) {
    const stateRef = useRef(state);
    stateRef.current = state;
    const optionsRef = useRef(options);
    optionsRef.current = options;
    useEffect(() => {
        assertStickyParentPosition(options, containerRef.current);
    }, []);
    useEffect(() => {
        let timerId = null;
        const update = () => {
            timerId = null;
            const nextState = getUpdatedStickyState(optionsRef.current, containerRef.current, childRef.current);
            if (hasStickyStateChanged(stateRef.current, nextState)) {
                onChange(nextState);
            }
        };
        const scheduleUpdate = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', scheduleUpdate);
        window.addEventListener('resize', scheduleUpdate);
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            window.removeEventListener('scroll', scheduleUpdate);
            window.removeEventListener('resize', scheduleUpdate);
        };
    }, [onChange]);
    useEffect(() => {
        const nextState = getUpdatedStickyState(optionsRef.current, containerRef.current, childRef.current);
        if (hasStickyStateChanged(stateRef.current, nextState)) {
            onChange(nextState);
        }
    }, [options, onChange]);
}
//# sourceMappingURL=useBaseSticky.js.map